import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#000000";
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    borderBottomColor: "#000000",
    backgroundColor: "white",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
  },
  description: {
    width: "40%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  qty: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  rate: {
    width: "15%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  amount: {
    width: "15%",
  },
});

const InvoiceTableHeader = () => (
  <View style={styles.container}>
    <Text style={styles.description}>Libellé</Text>
    <Text style={styles.description}>code</Text>
    <Text style={styles.qty}>quantité</Text>
    {/* <Text style={styles.rate}>Prix.Ht</Text>
    <Text style={styles.rate}>Prix.Tt</Text>
    <Text style={styles.rate}>Promotion</Text>
    <Text style={styles.amount}>Total.Tt</Text> */}
  </View>
);

export default InvoiceTableHeader;

// import React from 'react';
// import {Text, View, StyleSheet } from '@react-pdf/renderer';

// const borderColor = '#90e5fc'
// const styles = StyleSheet.create({
//     container: {
//         flexDirection: 'row',
//         borderBottomColor: '#bff0fd',
//         backgroundColor: '#bff0fd',
//         borderBottomWidth: 1,
//         alignItems: 'center',
//         height: 24,
//         textAlign: 'center',
//         fontStyle: 'bold',
//         flexGrow: 1,
//     },
//     description: {
//         width: '60%',
//         borderRightColor: borderColor,
//         borderRightWidth: 1,
//     },
//     qty: {
//         width: '10%',
//         borderRightColor: borderColor,
//         borderRightWidth: 1,
//     },
//     rate: {
//         width: '15%',
//         borderRightColor: borderColor,
//         borderRightWidth: 1,
//     },
//     amount: {
//         width: '15%'
//     },
//   });

//   const InvoiceTableHeader = () => (
//     <View style={styles.container}>
//         <Text style={styles.description}>Item Description</Text>
//         <Text style={styles.qty}>Qty</Text>
//         <Text style={styles.rate}>@</Text>
//         <Text style={styles.amount}>Amount</Text>
//     </View>
//   );

//   export default InvoiceTableHeader
